import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
import "./borderContainer.scss";
export const BorderContainer = memo(({ className = "", size = "default", marginBottom, children, testId }) => {
    return (_jsx("div", { className: classNames(["border-container", `border-container--${size}`, className]), "data-testid": testId, style: { marginBottom }, children: children }));
});
